import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPreziComponent } from './simple-icons-prezi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPreziComponent ],
    exports:      [ SimpleIconsPreziComponent ],
    bootstrap:    []
})
export class SimpleIconsPreziModule {}
